
import('/src/v4/file-manager.js').then(({ initFileManager }) => initFileManager());
